import styled from "styled-components";

export const Title = styled.span`
  margin-left: 10px;
`;

export const ExportForm = styled.form`
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
`;
